module.exports = __webpack_public_path__ + "img/dropoetin_video_.957b34b8.jpg";